import script from "./R3Notification.vue?vue&type=script&setup=true&lang=js"
export * from "./R3Notification.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__